import { GeothermalSystemDesign } from 'types';

export const calculateGeothermalSystemDesignTotalCost = (systemDesign: GeothermalSystemDesign): number => {
  return Math.round((systemDesign?.totalLeaseAmount || 0) * 100) / 100;
};
